import * as React from 'react';

import Progress from "../../../common/organism/progress";
import ClientProjectMainPreview from "./preview/client_project_main_preview";
import {Project} from "../../../../domain/model/project";
import {Company} from "../../../../domain/model/company";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import {TBreadcrumbItem} from "../../../type/common";
import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";

interface IProps {
    isLoading: boolean;
    project: Project | null;
    company: Company | null;
}

const ClientProjectPreviewComponent: React.FC<IProps> = (props) => {
    const {isLoading, project, company} = props;

    const projectName = project ? project.name : "";

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        routeConfig.clientProjects,
        {text: `[プレビュー]${projectName}`}
    ]

    return (
        <React.Fragment>
            {isLoading &&  <Progress canAnimation={false}/>}
            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems} />
                <ClientProjectMainPreview
                    project={project}
                    company={company}
                />
            </PageWrapper>
        </React.Fragment>
    )

};

export default ClientProjectPreviewComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/project/client_project_preview.tsx